import React, { Component } from 'react'
import CollectionList from '../collection-list'

// Case studies component wraps the common
// collection rows component to display 
// rows of collection slides 
// Consider - background canvas row - also not part of this?
class CaseStudies extends Component {

  componentDidMount() {
    this.requestRows()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.active === this.props.active) return
    this.requestRows()
  }

  // Request rows only if rows are empty
  // And active is set to true
  // Active is if route matches 
  requestRows() {
    const { rows, active, onRequestRows } = this.props

    if (rows) return
    if (!active) return
    
    onRequestRows && onRequestRows()
  }

  render() {
    return (
      <div className="case-studies">
        <CollectionList disableToggle={true} logo={true} {...this.props} />
      </div>
    )
  }
}

export default CaseStudies



// WEBPACK FOOTER //
// ./src/components/case-studies-container/case-studies.js